import { createFileRoute, Navigate } from "@tanstack/react-router";
import { SignedIn, SignedOut } from "@clerk/clerk-react";

import { Landing } from "@/components/landing";

export const Route = createFileRoute("/")({
  component: IndexComponent,
});

// The public root: Landing for signed-out visitors; already-signed-in visitors
// are sent to the authenticated home at /dashboard.
function IndexComponent() {
  return (
    <>
      <SignedOut>
        <Landing />
      </SignedOut>
      <SignedIn>
        <Navigate to="/dashboard" />
      </SignedIn>
    </>
  );
}
